// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"353":"89ffe433","888":"6b4681be","934":"e60f1098"}[chunkId] + ".css";
};